import { ArticleStatus } from '@pia/pia.shared';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'articleStatusColorPipe',
  pure: true,
})
export class ArticleStatusColorPipe implements PipeTransform {
  constructor() {}
  transform(item: ArticleStatus): string {
    let articleStatus = '';
    switch (item) {
      case ArticleStatus.Unknown:
        articleStatus = '#ffea9e';
        break;
      case ArticleStatus.Available:
        articleStatus = '#22be34';
        break;
      case ArticleStatus.Locked:
        articleStatus = '#ff6e6e';
        break;
      case ArticleStatus.DontUse:
        articleStatus = '#ffea9e';
        break;
      case ArticleStatus.NotAvailable:
        articleStatus = '#ff6e6e';
        break;
    }
    return articleStatus;
  }
}
